// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
// S-24 - Recibo
export const S24_FIELD_MAP = {
  data: { label: 'Data', section: 'Informações Gerais' },
  tipo_donativo: { label: 'Tipo: Donativo (marque com X)', section: 'Tipo' },
  tipo_pagamento: { label: 'Tipo: Pagamento (marque com X)', section: 'Tipo' },
  tipo_deposito_cofre: { label: 'Tipo: Depósito no cofre (marque com X)', section: 'Tipo' },
  tipo_dinheiro_adiantado: { label: 'Tipo: Dinheiro adiantado (marque com X)', section: 'Tipo' },
  valor_obra_mundial: { label: 'Donativos — Obra mundial (valor)', section: 'Valores' },
  valor_congregacao_local: { label: 'Donativos — Despesas da congregação local (valor)', section: 'Valores' },
  descricao_1: { label: 'Linha 1 — Descrição', section: 'Valores' },
  valor_1: { label: 'Linha 1 — Valor', section: 'Valores' },
  descricao_2: { label: 'Linha 2 — Descrição', section: 'Valores' },
  valor_2: { label: 'Linha 2 — Valor', section: 'Valores' },
  descricao_3: { label: 'Linha 3 — Descrição', section: 'Valores' },
  valor_3: { label: 'Linha 3 — Valor', section: 'Valores' },
  total: { label: 'TOTAL', section: 'Valores' },
  preenchido_por: { label: 'Preenchido por (nome)', section: 'Assinaturas' },
  conferido_por: { label: 'Conferido por (nome)', section: 'Assinaturas' },
};

export const S24_SECTION_COLORS = {
  'Informações Gerais': 'bg-blue-500',
  'Tipo': 'bg-amber-500',
  'Valores': 'bg-emerald-500',
  'Assinaturas': 'bg-rose-500',
};

export const S24_CONFIG = {
  formType: 's24',
  title: 'S-24',
  fullTitle: 'Recibo',
  fieldMap: S24_FIELD_MAP,
  sectionColors: S24_SECTION_COLORS,
  totalFields: 16,
};
